import React from 'react';
import './section3-p3.css';
import LocationInfo from '../components/common/LocationInfo';
import LocationMap from '../components/common/LocationMap';

const SectionThreeP3 = () => {
  return (
    <section className="p3-section-three">
      <div className="p3-container">
        <LocationInfo />
        <LocationMap />
      </div>
    </section>
  );
};

export default SectionThreeP3;